import SignalsCreateView from "app/pages/sales-intelligence/sub-modules/signals/components/views/SignalsCreateView/SignalsCreateView";
import withTrackedSignalView from "app/pages/sales-intelligence/sub-modules/signals/hoc/withTrackedSignalView";
import withSignalCreateSubmit from "../../hoc/withSignalCreateSubmit";

const SignalsCreateViewContainer = withTrackedSignalView(withSignalCreateSubmit(SignalsCreateView));

export default SignalsCreateViewContainer;
